// FAQページにのみスクリプトを適用する
if ($('.p-faq').length > 0) {
  $(document).on('click', '.tab', function (e) {
    let index = $(this).index();
    if(!$(this).hasClass('is-active')){
      // ボタンのスタイルを変更
      $('.tab').removeClass('is-active');
      $('.tabs').each(function() {
        $(this).find('.tab').eq(index).addClass('is-active');
      });
      // コンテンツを切替
      $('[data-panel]').removeClass('is-active');
      $(`[data-panel="${index}"]`).addClass('is-active');
    }
  });
}